<template>
  <div>
    <van-popup v-model="showCustomerInfo" class="backRect" get-container="body" @closed="onClosed">
      <TopBar :pagetitle="title" :is-left-self="true" class="flexTop" @leftClick="onBack" />
      <div class="fullRect">
        <template v-if="showType === 'easy'">
          <div class="fastRect">
            <div class="title">基本信息<span>请准确填写下列信息</span></div>
            <van-field
              v-model="customerInfoDataBase.loaclName"
              clearable
              label="中文姓名"
              maxlength="64"
              required
              placeholder="请输入中文姓名"
              @blur="onLocalNameBlur"
            />
            <van-field
              v-model="customerInfoDataBase.lastName"
              clearable
              label="英文(拼音)姓"
              maxlength="32"
              required
              placeholder="请输入英文(拼音)姓"
            />
            <van-field
              v-model="customerInfoDataBase.firstName"
              clearable
              label="英文(拼音)名"
              maxlength="32"
              required
              placeholder="请输入英文(拼音)名"
            />
            <van-field
              v-model="birthdayBase"
              clearable
              label="生日"
              required
              readonly=""
              placeholder="请选择出生日期"
              @click="showBirthdayBase=true"
            />
            <van-field
              v-model="customerInfoDataBase.phone"
              clearable
              label="手机号码"
              maxlength="11"
              required
              placeholder="请输入手机号码"
            />
          </div>
          <div class="downButtonBase">
            <van-button type="danger" size="large" :color="GetColorMain()" style="width:100%" :loading="buttonLoading" loading-text="保存中..." @click="editCustomerBase">保存</van-button>
          </div>
        </template>

        <template v-if="showType !== 'easy' && isFirstStep">
          <div class="fastRect">
            <div class="title">基本信息<span>请准确填写下列信息</span></div>
            <van-field
              v-model="customerInfoDataBase.loaclName"
              clearable
              label="中文姓名"
              maxlength="64"
              required
              placeholder="请输入中文姓名"
              @blur="onLocalNameBlur"
            />
            <van-field
              v-model="customerInfoDataBase.lastName"
              clearable
              label="英文(拼音)姓"
              maxlength="32"
              required
              placeholder="请输入英文(拼音)姓"
            />
            <van-field
              v-model="customerInfoDataBase.firstName"
              clearable
              label="英文(拼音)名"
              maxlength="32"
              required
              placeholder="请输入英文(拼音)名"
            />
            <van-field
              v-model="customerInfoDataBase.idCardNumber"
              clearable
              label="身份证号码"
              maxlength="32"
              required
              placeholder="请输入身份证号码"
              @input="onGetIdCardInfo"
            />
            <van-field
              v-model="customerInfoDataBase.passportNumber"
              clearable
              label="护照号码"
              maxlength="32"
              required
              placeholder="请输入护照号码"
            />
            <van-field
              v-model="birthdayBase"
              clearable
              label="生日"
              required
              readonly=""
              placeholder="请选择出生日期"
              @click="showBirthdayBase=true"
            />
            <van-field
              v-model="customerInfoDataBase.phone"
              clearable
              label="手机号码"
              maxlength="11"
              required
              placeholder="请输入手机号码"
            />
          </div>
          <div class="downButtonBase">
            <van-button type="danger" size="large" :color="GetColorMain()" style="width:100%" :loading="buttonLoading" loading-text="保存中..." @click="editCustomerBase">保存</van-button>
          </div>
        </template>
        <template v-if="showType!=='easy' && !isFirstStep">
          <div class="fastRect">
            <div class="title">基本信息<span>请准确填写下列信息</span></div>
            <van-field
              v-model="customerInfoData.loaclName"
              clearable
              :disabled="showType!=='manage' && !isEmptyStr(customerInfoData.loaclName)"
              label="中文姓名"
              maxlength="32"
              required
              placeholder="请输入中文姓名"
            />
            <van-field
              v-model="customerInfoData.lastName"
              clearable
              :disabled="showType!=='manage' && !isEmptyStr(customerInfoData.lastName)"
              label="英文(拼音)姓"
              maxlength="32"
              required
              placeholder="请输入英文(拼音)姓"
            />
            <van-field
              v-model="customerInfoData.firstName"
              clearable
              :disabled="showType!=='manage' && !isEmptyStr(customerInfoData.firstName)"
              label="英文(拼音)名"
              maxlength="32"
              required
              placeholder="请输入英文(拼音)名"
            />
            <van-field
              v-model="customerInfoData.idCardNumber"
              clearable
              label="身份证号码"
              maxlength="32"
              required
              placeholder="请输入身份证号码"
            />
            <van-field
              v-model="customerInfoData.passportNumber"
              clearable
              label="护照号码"
              maxlength="32"
              required
              placeholder="请输入护照号码"
            />
            <van-field
              v-model="birthday"
              clearable
              :disabled="showType!=='manage' && !isEmptyStr(birthday)"
              label="生日"
              required
              readonly=""
              placeholder="请选择出生日期"
              @click="onShowBirthday(showType!=='manage' && !isEmptyStr(birthday))"
            />
            <div v-if="showType!=='manage'" class="canteditAbout">
              <i class="iconfont iconguanyu" :style="'color:'+GetColorMain()" /> 如需修改姓名、生日，请联系客服。
            </div>
            <van-field
              v-model="customerInfoData.email"
              clearable
              label="邮箱"
              maxlength="128"
              required
              placeholder="请输入电子邮箱"
            />
            <div class="canteditAbout">
              <i class="iconfont iconguanyu" :style="'color:'+GetColorMain()" /> 请填写自己的准确的电子邮箱以免无法正常注册证书。
            </div>
            <van-field
              v-model="customerInfoData.phone"
              clearable
              label="手机号码"
              maxlength="11"
              required
              placeholder="请输入手机号码"
            />

            <FieldSelect v-model="sex" :list="sexList" label="性别" placeholder="请选择性别" @change="onSexChange" />
            <div class="van-cell van-field">
              <div class="van-cell__title van-field__label"><span>是否考证</span></div>
              <div class="van-cell__value"><van-checkbox v-model="isStudent" :checked-color="GetColorMain()">是（补充信息）</van-checkbox></div>
            </div>
          </div>
          <div v-show="isStudent" class="fastRect">
            <div class="title">邮寄信息<span>请如实填写信息</span></div>
            <div v-for="item in addressList" :key="item.id" class="baseAddress" @click="onClickAddress(item)">
              {{ item.name }}， {{ item.phoneCountry }} {{ item.tel }}
              <div>{{ item.zipString }}{{ item.address }}</div>
            </div>
            <FieldSelect v-model="customerInfoData.country" :list="countryList" label="国家" placeholder="请选择国家" @change="onCountryChange" />
            <van-field
              v-if="customerInfoData.country==='CHN'"
              v-model="zip"
              required
              clearable
              label="地区"
              placeholder="选择省/市/区"
              readonly
              @click="selectArea"
            />
            <van-field
              v-model="customerInfoData.address"
              clearable
              label="地址"
              maxlength="256"
              required
              placeholder="街道门牌、楼层房间号等信息"
            />
            <van-field
              v-model="customerInfoData.postalCode"
              clearable
              label="邮编"
              maxlength="12"
              required
              placeholder="请输入邮政编码"
            />

          </div>
          <div class="fastRect">
            <div class="title">补充信息<span>选填</span></div>
            <van-field
              v-model="customerInfoData.height"
              clearable
              label="身高"
              maxlength="32"
              placeholder="请输入身高"
            />
            <van-field
              v-model="customerInfoData.weight"
              clearable
              label="体重(公斤)"
              maxlength="32"
              placeholder="请输入体重(公斤)"
            />
            <van-field
              v-model="customerInfoData.shoeSize"
              clearable
              label="鞋码"
              maxlength="32"
              placeholder="请输入鞋码"
            />
            <van-field
              v-model="customerInfoData.nowLicense"
              clearable
              label="潜水组织和证书"
              maxlength="32"
              placeholder="例如PADI AOW"
            />
            <van-field
              v-model="customerInfoData.totalDiving"
              clearable
              label="总潜水次数"
              maxlength="32"
              placeholder="例如 100次"
            />
            <van-field
              v-model="customerInfoData.lastDiveDate"
              clearable
              label="最后一次潜水时间"
              maxlength="32"
              placeholder="例如 2020年1月"
            />
            <van-field
              v-model="customerInfoData.emergencyName"
              clearable
              label="紧急联系人"
              maxlength="16"
              placeholder="请输入紧急联系人姓名"
            />
            <van-field
              v-model="customerInfoData.emergencyContact"
              clearable
              label="紧急联系方式"
              maxlength="32"
              placeholder="请输入紧急联系人联系方式"
            />
          </div>
          <div v-show="isStudent" class="fastRect">
            <div class="title">认证照片<span>请上传本人照片</span></div>
            <div class="IconRect">
              <div class="tools" @click="rotateImg"><i class="iconfont iconrotate" /></div>
              <vueCropper
                ref="cropper"
                class="cutIconRect"
                :img="option.img"
                :output-size="option.size"
                :output-type="option.outputType"
                :info="false"
                :full="option.full"
                :can-move="option.canMove"
                :can-move-box="option.canMoveBox"
                :original="option.original"
                :auto-crop="option.autoCrop"
                :fixed="option.fixed"
                :fixed-number="option.fixedNumber"
                :center-box="option.centerBox"
                :fixed-box="option.fixedBox"
                :max-img-size="option.maxImgSize"
                :enlarge="option.enlarge"
                :auto-crop-width="option.autoCropWidth"
                :auto-crop-height="option.autoCropHeight"
              />
              <van-uploader :after-read="onRead">
                <van-button type="default" size="small" class="buttonChooseImg" :color="GetColorMain()">选择照片</van-button>
              </van-uploader>
              <div class="photoAbout">注:该照片用于帮助识别持卡人,请勿带墨镜/潜水面镜/帽子。如您提交了不符合要求的照片,将有可能延迟您的卡片认证。</div>
              <div class="photoAbout" :style="'color:'+GetColorMain()">注:请选择相册中已有照片,部分机型不支持拍摄。</div>
            </div>
          </div>
          <div class="downButton">
            <template v-if="id &&!orderId">
              <van-button :color="GetColorMain()" style="width:50%" type="default" size="large" plain :loading="buttonLoading" loading-text="删除中..." @click="deleteCustomer">删除</van-button>
              <van-button type="danger" size="large" :color="GetColorMain()" style="width:50%" :loading="buttonLoading" loading-text="保存中..." @click="editCustomer">保存</van-button>
            </template>
            <van-button v-else type="danger" size="large" :color="GetColorMain()" style="width:100%" :loading="buttonLoading" loading-text="保存中..." @click="editCustomer">保存</van-button>
          </div>
        </template>
      </div>
    </van-popup>
    <dateSelect v-model="showBirthday" :default-date="birthday" @onChange="onBirthdayChange" />
    <dateSelect v-model="showBirthdayBase" :default-date="birthdayBase" @onChange="onBirthdayChangeBase" />
    <van-popup v-model="showAreaSelect" position="bottom">
      <van-area ref="pickerArea" :value="customerInfoData.zip==undefined?'110000':customerInfoData.zip.toString()" :loading="arealoading" :area-list="areaData" @confirm="confirmArea" @cancel="showAreaSelect=false" />
    </van-popup>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Field, Popup, Area, Uploader, Dialog, Checkbox } from 'vant'
import FieldSelect from '@/components/FieldSelect'
import TopBar from '@/components/TopBar'
import { isEmptyStr, ShowMoney, GetEnumText, formatDate, MyNotify } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import dateSelect from '@/components/dateSelect'
import { VueCropper } from 'vue-cropper'
export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Area.name]: Area,
    [Uploader.name]: Uploader,
    [Dialog.name]: Dialog,
    [Checkbox.name]: Checkbox,
    TopBar,
    FieldSelect,
    dateSelect,
    VueCropper
  },
  props: {
    // eslint-disable-next-line
    value:undefined,
    // eslint-disable-next-line
    showType:undefined
  },
  data() {
    return {
      showCustomerInfo: undefined,
      title: '编辑人员信息',
      orderId: undefined, // 同时要处理的订单序号
      isFirstStep: true,
      id: undefined,
      showBirthday: false,
      showBirthdayBase: false,
      birthday: undefined,
      birthdayBase: undefined,
      customerInfoData: {

      },
      customerInfoDataBase: {
        loaclName: undefined,
        firstName: undefined,
        lastName: undefined,
        phone: undefined,
        birthday: undefined,
        idCardNumber: '',
        PassportNumber: '',
        sex: undefined
      },
      customerInfoDataBaseSave: {

      },

      sex: undefined,
      sexList: [],
      countryList: [],
      zip: undefined,
      areaData: undefined,
      arealoading: false,
      showAreaSelect: false,
      changeUserHead: false,
      buttonLoading: false,
      isStudent: true,
      addressList: [],
      option: {
        img: '', // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: 'jpg', // 裁剪生成图片的格式
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [10, 13], // 截图框的宽高比例
        full: false, // 是否输出原图比例的截图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        maxImgSize: 2000,
        enlarge: 1,
        autoCropWidth: 200,
        autoCropHeight: 260
      }
    }
  },
  watch: {
    value(newValue) {
      if (newValue !== null && newValue !== undefined) {
        this.id = newValue
        this.showCustomerInfo = true
        console.log('顾客管理:业务类型:' + this.showType)
        this.init()
      } else {
        this.id = undefined
        this.showCustomerInfo = false
      }
    }
  },

  created() {
    
    this.customerInfoDataBaseSave = JSON.parse(JSON.stringify(this.customerInfoDataBase))
    // this.orderId = getUrlKey('orderId')
    // this.id = getUrlKey('id')
    // if (this.id) {
    //   this.onInit(() => {
    //     this.titleTop = GetSysTitle()
    //   })
    // }
    // const type = getUrlKey('type')
    // if (type) {
    //   switch (type) {
    //     case 'simple':
    //       this.type = type
    //       break
    //     default :
    //       this.type = 'normal'
    //       break
    //   }
    // } else {
    //   this.type = 'normal'
    // }
    // this.onInitAddressList()
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    isEmptyStr,
    onClosed() {
      this.$emit('input', null)
    },
    onBack() {
      this.showCustomerInfo = false
      return true
    },
    init() {
      this.isFirstStep = true
      if (this.id === 0 || this.id === '0') {
        this.title = '新增顾客信息'
        this.customerInfoDataBase = JSON.parse(JSON.stringify(this.customerInfoDataBaseSave))
        setTimeout(() => {
          this.onInitCountry();
        }, 1);
      } else {
        this.title = '编辑顾客信息'
        this.onInit()
        
      }
    },
    onInitCountry(callback){
      if(this.countryList.length>0)
      {
        if( callback ){
          callback();
        }
        return;
      }
      request({
        url: '/data/getCountryList',
        method: 'post'
      }).then(Response => {
        if (Response.success) {
          this.countryList = []
          Response.data.forEach(el=>{
            this.countryList.push({ text: el.name, value: el.code3 })
          })
          if(callback)
          {
            callback();
          }
        }
      })
    },
    onInit(callback) {
      request({
        url: '/storeHelper/getBusinessCustomerInfo',
        method: 'post',
        data: {
          type: this.showType,
          id: this.id
        }
      }).then(response => {
        if (!response.success) {
          return
        }
        if (!response.data) {
          MyNotify('error', '读取数据失败!', 2000)
          return
        }
        if (this.showType === 'easy') {
          this.customerInfoDataBase = response.data
          if (response.data.birthday) {
            this.birthdayBase = formatDate(response.data.birthday, 'yyyy/MM/dd')
          } else {
            this.birthdayBase = undefined
          }
          return
        }

        this.customerInfoData = response.data
        this.zip = response.data.zipString
        if (response.data.birthday) {
          this.birthday = formatDate(response.data.birthday, 'yyyy/MM/dd')
        } else {
          this.birthday = undefined
        }
        if (this.customerInfoData.headIcon) {
          this.option.img = this.customerInfoData.headIcon
        } else {
          this.option.img = undefined
        }
        this.isStudent = this.customerInfoData.zip
        this.isFirstStep = false
        if (callback) {
          callback()
        }
        setTimeout(() => {
          this.sexList = []
          this.sexList.push({ text: '男性', value: 'MALE' })
          this.sexList.push({ text: '女性', value: 'FEMALE' })
          this.sex = undefined
          setTimeout(() => {
            this.sex = this.customerInfoData.sex
          }, 1)

          let country = this.customerInfoData.country;
          this.customerInfoData.country =undefined;
          this.onInitCountry(()=>{
            this.customerInfoData.country =country;
          })
        }, 1)
      })
    },
    onInitAddressList(callback) {
      request({
        url: '/StoreHelper/getUserAddressModelList',
        method: 'post'
      }).then(Response => {
        if (Response.success) {
          this.addressList = Response.data
        }
      })
    },
    onClickAddress(item) {
      this.zip = item.zipString
      this.customerInfoData.zip = item.zip
      this.customerInfoData.address = item.address
    },
    onSexChange(select) {
      this.customerInfoData.sex = select.value
    },
    onCountryChange(select) {
      this.customerInfoData.country = select.value
    },
    onBirthdayChange(date) {
      console.log('onBirthdayChange', date)
      this.customerInfoData.birthday = date
      if (date) {
        this.birthday = formatDate(date, 'yyyy/MM/dd')
      } else {
        this.birthday = undefined
      }
    },
    onBirthdayChangeBase(date) {
      console.log('onBirthdayChangeBase', date)
      this.customerInfoDataBase.birthday = date
      if (date) {
        this.birthdayBase = formatDate(date, 'yyyy/MM/dd')
      } else {
        this.birthdayBase = undefined
      }
    },
    selectArea() {
      this.showAreaSelect = true
      this.readAreaData()
    },
    readAreaData() {
      if (this.areaData !== undefined) {
        return
      }
      this.arealoading = true
      request({
        url: '/data/getArea',
        method: 'post'
      }).then(Response => {
        this.areaData = Response
        this.arealoading = false
      })
    },
    confirmArea(selectList) {
      var title = ''
      var zipId = 0
      selectList.forEach(item => {
        title += item.name + ' '
        zipId = item.code
      })
      this.zip = title
      this.customerInfoData.zip = zipId
      this.showAreaSelect = false
    },
    onRead(file) {
      this.option.img = file.content
      this.changeUserHead = true
    },
    rotateImg() {
      if (this.option.img === undefined || this.option.img == null || this.option.img === '') {
        return
      }
      this.$refs.cropper.rotateRight()
    },
    deleteCustomer() {
      Dialog.confirm({
        title: '删除顾客信息',
        message: '是否要删除这条顾客信息数据',
        cancelButtonText: '取消',
        confirmButtonText: '删除'
      }).then(() => {
        this.deleteCustomerDo()
      })
    },
    deleteCustomerDo() {
      this.buttonLoading = true
      request({
        url: '/StoreHelper/deleteCustomerInfo',
        method: 'post',
        params: { customerLogId: this.id }
      }).then(Response => {
        this.buttonLoading = false
        if (Response.success) {
          MyNotify('success', '删除顾客信息成功', 2000)
          this.showCustomerInfo = false
          this.$emit('reload')
        }
      })
    },
    checkInputData(data) {
      if (!data.loaclName || data.loaclName.length < 1) {
        MyNotify('info', '请输入至少2位中文姓名')
        return false
      }
      if (!data.lastName || data.lastName.length < 1) {
        MyNotify('info', '请输入英文(拼音)姓')
        return false
      }
      if (!data.firstName || data.firstName.length < 1) {
        MyNotify('info', '请输入英文(拼音)名')
        return false
      }
      if (!data.birthday) {
        MyNotify('info', '请选择出生日期')
        return false
      }
      if (!data.email || data.email.length < 5) {
        MyNotify('info', '请输入电子邮箱')
        return false
      }
      if (!data.sex || data.sex.length < 1 || data.sex === 'NONE') {
        MyNotify('info', '请选择性别')
        return false
      }
      if (!data.phone || data.phone.length < 11) {
        MyNotify('info', '请输入11位手机号码')
        return false
      }
      if (!data.passportNumber) {
        MyNotify('info', '请输入护照号码')
        return false
      }
      if (!data.idCardNumber) {
        MyNotify('info', '请输入身份证号码')
        return false
      }
      if (this.isStudent) {
        if(this.customerInfoData.country === 'CHN'){
          if (!data.zip || data.zip.length < 1) {
            MyNotify('info', '选择省/市/区')
            return false
          }
        }
        if (!data.address || data.address.length < 1) {
          MyNotify('info', '请输入街道门牌、楼层房间号等信息')
          return false
        }
        if (!data.postalCode || data.postalCode.length < 4) {
          MyNotify('info', '请输入邮政编码')
          return false
        }
        if (!this.option.img || this.option.img === '') {
          MyNotify('info', '请上传认证照片')
          return false
        }
      }
      return true
    },
    editCustomer(callback) {
      if (!this.checkInputData(this.customerInfoData)) {
        return
      }
      this.buttonLoading = true
      if (this.changeUserHead) {
        var height = this.$refs.cropper.cropH
        var bl = 260.0 / height
        this.option.enlarge = bl
        this.$refs.cropper.getCropData((data) => {
          this.customerInfoData.data = data
          this.saveFormdata(this.customerInfoData, (id) => {
            this.id = id
            MyNotify('success', '顾客信息修改成功', 2000)
            this.showCustomerInfo = false
            this.$emit('reload')
          })
        })
      } else {
        this.customerInfoData.data = undefined
        this.saveFormdata(this.customerInfoData, (id) => {
          this.id = id
          MyNotify('success', '顾客信息修改成功', 2000)
          this.showCustomerInfo = false
          this.$emit('reload')
        })
      }
    },
    saveFormdata(data, callback) {
      data.isProUsed = false
      data.useType = this.showType
      data.id = this.id
      request({
        url: '/StoreHelper/updateCustomerInfo',
        method: 'post',
        data: data
      }).then(Response => {
        this.buttonLoading = false
        if (!Response.success) {
          return
        }
        if (callback) {
          callback(Response.data)
        }
      })
    },
    onGetIdCardInfo() {
      this.customerInfoDataBase.idCardNumber = this.customerInfoDataBase.idCardNumber.trim()
      if (this.customerInfoDataBase.idCardNumber.length !== 18) {
        return
      }
      request({
        url: '/User/getUserIdCardInfo',
        method: 'post',
        params: { id: this.customerInfoDataBase.idCardNumber }
      }).then(Response => {
        if (!Response.success) {
          return
        }
        if (!Response.data.isSuccess) {
          MyNotify('info', '身份证号码异常，请检查')
          return
        }
        this.customerInfoDataBase.birthday = Response.data.birthday
        this.birthdayBase = formatDate(Response.data.birthday, 'yyyy/MM/dd')
        this.customerInfoDataBase.sex = Response.data.sex
      })
    },
    editCustomerBase() {
      if (!this.customerInfoDataBase.loaclName || this.customerInfoDataBase.loaclName.length < 1) {
        MyNotify('info', '请输入至少2位中文姓名')
        return
      }
      if (!this.customerInfoDataBase.lastName || this.customerInfoDataBase.lastName.length < 1) {
        MyNotify('info', '请输入英文(拼音)姓')
        return
      }
      if (!this.customerInfoDataBase.firstName || this.customerInfoDataBase.firstName.length < 1) {
        MyNotify('info', '请输入英文(拼音)名')
        return
      }
      if (!this.customerInfoDataBase.phone || this.customerInfoDataBase.phone.length < 11) {
        MyNotify('info', '请输入11位手机号码')
        return
      }
      if (!this.customerInfoDataBase.birthday) {
        MyNotify('info', '请选择出生日期')
        return false
      }
      if (this.showType !== 'easy') {
        if (!this.customerInfoDataBase.passportNumber) {
          MyNotify('info', '请输入护照号码')
          return false
        }
        if (!this.customerInfoDataBase.idCardNumber) {
          MyNotify('info', '请输入身份证号码')
          return false
        }
      }
      this.saveFormdata(this.customerInfoDataBase, (id) => {
        if (this.showType === 'easy') {
          MyNotify('success', '顾客信息添加成功', 2000)
          this.showCustomerInfo = false
          this.$emit('reload')
        } else {
          this.id = id
          this.onInit()
          MyNotify('success', '添加成功,请完善详细信息!', 5000)
        }
        // Dialog.confirm({
        //   title: '添加成功',
        //   message: '添加成功,是否要继续添加?',
        //   confirmButtonText: '添加',
        //   cancelButtonText: '返回'
        // }).then(() => {
        //   this.id = undefined
        //   this.customerInfoDataBase = JSON.parse(JSON.stringify(this.customerInfoDataBaseSave))
        // }).catch(() => {
        //   this.showCustomerInfo = false
        //   this.$emit('reload')
        // })
      })
    },
    onLocalNameBlur() {
      // console.log('onLocalNameBlur', this.customerInfoDataBase.loaclName)
      request({
        url: '/User/getNamePy',
        method: 'post',
        params: { name: this.customerInfoDataBase.loaclName }
      }).then(Response => {
        if (!Response.success) {
          return
        }
        this.customerInfoDataBase.lastName = Response.data.lastName
        this.customerInfoDataBase.firstName = Response.data.firstName
      })
    },
    onShowBirthday(cantShow) {
      if (!cantShow) {
        this.showBirthday = true
      }
    }
  }
}
</script>
<style>
.van-uploader{
  width: 100% !important;
}
.van-uploader__input-wrapper{
  width: 100% !important;
}
.uploadbutton button{
  width: 100%;
}
</style>
<style scoped>
.fullRect{
  height: calc(100vh - 3em);
  overflow-y: scroll;
}
.backRect{
    width: 100vw;
    height: 100vh;
    background-color: #F1f1f1;
}
.downButton{
    margin: 1em;
}
.downButtonBase{
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  height: 3em;
}
.fastRect{
    background-color: #fff;
    border-radius: 0.3em;
    padding: 0.5em;
    margin: 1em;
}
.fastRect .title{
    font-size: 1.1em;
    font-weight: 700;
    padding: 0.3em 0 0.3em 0.9em;
}
.fastRect .title span{
  font-size: 0.7em;
  color: #999;
  padding-left: 0.4em;
  font-weight: 400;
}
.cutIconRect{
    width: 100%;
    height: 15em !important;
}
.tools{
  position: absolute;
  right: 0.5em;
  top:0.5em;
  z-index: 999;
  width: 2em;
  height: 2em;
  line-height: 2em;
  border-radius: 1em;
  text-align: center;
  background-color: #fff;
}
.IconRect{
  overflow: hidden;
  position: relative;
}
.buttonChooseImg{
  width: 100%;
  color: #fff;
  border:none;
  border-bottom-left-radius: 0.4em;
  border-bottom-right-radius: 0.4em;
  height: 3em;
  line-height: 3em;
}
.photoAbout{
  margin-top: 0.5em;
  padding: 0 0.5em;
  font-size: 0.6em;
  color: #999;
}
.baseAddress{
  border: 1px solid #ccc;
  margin: 0.5em;
  padding:0.3em;
}
.baseAddress div{
  font-size: 0.8em;
  color: #999;
}
.canteditAbout{
  color: #999;
  font-size: 0.8em;
  padding: 1em 0;
  margin-left: 1em;
  border-bottom: 1px solid #ebedf0;
}
</style>
